module.exports = __webpack_public_path__ + "img/yq.4eaa7f22.jpeg";